export const studentTerm = {
  name: 'terms_student_text',
  isReadonly: false,
  title: 'TERMOS E CONDIÇÕES DE USO DA PLATAFORMA LETRUS',
  id: 'terms_student_version_id',
};

export const privacyTerm = {
  name: 'terms_privacy_text',
  isReadonly: true,
  title: 'POLÍTICA DE PRIVACIDADE',
  id: 'terms_privacy_version_id',
};

export const acceptTerm = [
  {
    name: 'terms_student_text',
    isReadonly: false,
    title: 'TERMOS E CONDIÇÕES DE USO DA PLATAFORMA LETRUS',
    id: 'terms_use_version_id',
  },
  {
    name: 'terms_student_contest_text',
    isReadonly: false,
    title: 'TERMOS E CONDIÇÕES DE USO DA PLATAFORMA LETRUS',
    id: 'terms_use_version_id',
  },
];
